<template>
  <div
    v-if="isSummaryCell"
    class="m-table-cell m-table-cell-name__summary"
  >
    <span>—</span>
  </div>

  <MTableCellIcon
    v-else
    :icon="channelIcon"
    :text="itemText"
    :icon-size="{width: '16px', height: '16px'}"
    class="m-table-cell-name-icon"
  />
</template>

<script>
  import MTableCellIcon from 'modules/common/components/MTable/cells/MTableCellIcon';
  import {getIconConnectionById} from 'utils/seller/sellerConnectionData';

  export default {
    name: 'MTableCellNameIcon',
    components: {MTableCellIcon},
    props: {
      channelKey: {
        type: String,
        default: 'channel_id'
      },
      itemKey: {
        type: String,
        default: ''
      },
      tableRow: {
        type: Object,
        default: Object
      },
      withSummaryRow: {
        type: Boolean,
        default: false
      },
      index: {
        type: [Number, null],
        default: null
      }
    },
    computed: {
      itemText () {
        return this.tableRow[this.itemKey];
      },
      isSummaryCell () {
        return this.withSummaryRow && this.index === 0;
      },
      channelIcon () {
        return getIconConnectionById(this.tableRow[this.channelKey]);
      }
    }
  };
</script>

<style>
  .m-table-cell-name-icon {
    font-size: var(--font-size-xs);
  }

  .m-table-cell-name__summary {
    height: 36px;
    display: flex;
    align-items: center;
  }
</style>
